import DashboardLayout from "@/pages/Dashboard/Layout/DashboardLayout.vue";
import AuthLayout from "@/pages/Dashboard/Pages/AuthLayout.vue";
import Landing from "@/pages/Dashboard/Landing.vue";
import MainNavbar from "@/pages/Dashboard/Layout/MainNavbar.vue";
import LandingFooter from "@/pages/Dashboard/Layout/LandingFooter.vue";

//PathNotFound
import PathNotFound from "@/pages/PathNotFound.vue";
// Dashboard pages
import Dashboard from "@/pages/Dashboard/Dashboard.vue";
// Profile
// import UserProfile from "@/pages/Dashboard/Examples/UserProfile.vue";

// User Management
import ListUserPage from "@/pages/Dashboard/Examples/UserManagement/ListUserPage.vue";

// Pages
import RtlSupport from "@/pages/Dashboard/Pages/RtlSupport.vue";
import Login from "@/pages/Dashboard/Pages/Login.vue";
import Register from "@/pages/Dashboard/Pages/Register.vue";

// Components pages
import Notifications from "@/pages/Dashboard/Components/Notifications.vue";
import Icons from "@/pages/Dashboard/Components/Icons.vue";
import Typography from "@/pages/Dashboard/Components/Typography.vue";
// import Parallax from "@/pages/Dashboard/Components/Parallax.vue";

// TableList pages
import RegularTables from "@/pages/Dashboard/Tables/RegularTables.vue";

// Maps pages
import FullScreenMap from "@/pages/Dashboard/Maps/FullScreenMap.vue";

//import middleware
import auth from "@/middleware/auth";
import guest from "@/middleware/guest";
import admin from "@/middleware/admin";

import UserProfile from "@/pages/Dashboard/UserProfile.vue";

//admin
import ListUserPageTest from "@/pages/Dashboard/Admin/UserManagement/ListUserPage.vue";
import AddUserPageTest from "@/pages/Dashboard/Admin/UserManagement/AddUserPage.vue";
import EditUserPageTest from "@/pages/Dashboard/Admin/UserManagement/EditUserPage.vue";

import ListRole from "@/pages/Dashboard/Admin/Role/ListRolePage.vue";
import AddRole from "@/pages/Dashboard/Admin/Role/AddRolePage.vue";
import EditRole from "@/pages/Dashboard/Admin/Role/EditRolePage.vue";

//fms
import DashboardFms from "@/pages/Dashboard/Fms/Dashboard.vue";
import ListBusinessUnit from "@/pages/Dashboard/Fms/BusinessUnit/ListBUPage.vue";
import ListCity from "@/pages/Dashboard/Fms/City/ListCPage.vue";
import ListDpAmount from "@/pages/Dashboard/Fms/DpAmount/ListDPPage.vue";
import ListDriver from "@/pages/Dashboard/Fms/Driver/ListDPage.vue";
import ListDriverDp from "@/pages/Dashboard/Fms/DriverDp/ListDDPage.vue";
import ListPaymentPlan from "@/pages/Dashboard/Fms/PaymentPlan/ListPPPage.vue";
import ListPko from "@/pages/Dashboard/Fms/Pko/ListPPage.vue"
import ListSpj from "@/pages/Dashboard/Fms/Spj/ListSPage.vue";
import ListCashier from "@/pages/Dashboard/Fms/Cashier/ListCPage.vue";
import ListVehicle from "@/pages/Dashboard/Fms/Vehicle/ListVPage.vue";

//workshop
import DashboardWorkshop from "@/pages/Dashboard/Workshop/Dashboard.vue";

import ListServiceCategories from "@/pages/Dashboard/Workshop/ServiceCategories/ListSCPage.vue";
import AddServiceCategories from "@/pages/Dashboard/Workshop/ServiceCategories/AddSCPage.vue";
import EditServiceCategories from "@/pages/Dashboard/Workshop/ServiceCategories/EditSCPage.vue";

import ListServiceMaster from "@/pages/Dashboard/Workshop/ServiceMaster/ListSMPage.vue";
import AddServiceMaster from "@/pages/Dashboard/Workshop/ServiceMaster/AddSMPage.vue";
import EditServiceMaster from "@/pages/Dashboard/Workshop/ServiceMaster/EditSMPage.vue";

import ListClientMaster from "@/pages/Dashboard/Workshop/ClientMaster/ListCMPage.vue";
import AddClientMaster from "@/pages/Dashboard/Workshop/ClientMaster/AddCMPage.vue";
import EditClientMaster from "@/pages/Dashboard/Workshop/ClientMaster/EditCMPage.vue";

import ListFaktur from "@/pages/Dashboard/Workshop/Faktur/ListFakturPage.vue";
import AddFaktur from "@/pages/Dashboard/Workshop/Faktur/AddFakturPage.vue";
import EditFaktur from "@/pages/Dashboard/Workshop/Faktur/EditFakturPage.vue";
import DetailFaktur from "@/pages/Dashboard/Workshop/Faktur/DetailFaktur.vue";
import PdfFaktur from "@/pages/Dashboard/Workshop/Faktur/PdfFaktur.vue";

import ListPartDealer from "@/pages/Dashboard/Workshop/PartDealer/ListPDPage.vue";
import AddPartDealer from "@/pages/Dashboard/Workshop/PartDealer/AddPDPage.vue";
import EditPartDealer from "@/pages/Dashboard/Workshop/PartDealer/EditPDPage.vue";

import ListPKB from "@/pages/Dashboard/Workshop/PKB/ListPKBPage.vue";
import DetailPKB from "@/pages/Dashboard/Workshop/PKB/DetailPKBPage.vue";
import AddPKB from "@/pages/Dashboard/Workshop/PKB/AddPKBPage.vue";
import EditPKB from "@/pages/Dashboard/Workshop/PKB/EditPKBPage.vue";

import ListProcurementOrder from "@/pages/Dashboard/Workshop/ProcurementOrder/ListPOPage.vue";
import AddProcurementOrder from "@/pages/Dashboard/Workshop/ProcurementOrder/AddPOPage.vue";
import EditProcurementOrder from "@/pages/Dashboard/Workshop/ProcurementOrder/EditPOPage.vue";
import DetailProcurementOrder from "@/pages/Dashboard/Workshop/ProcurementOrder/DetailPOPage.vue";

import ListServiceEstimate from "@/pages/Dashboard/Workshop/ServiceEstimate/ListSEPage.vue";
import DetailServiceEstimate from "@/pages/Dashboard/Workshop/ServiceEstimate/DetailSEPage.vue";
import AddServiceEstimate from "@/pages/Dashboard/Workshop/ServiceEstimate/AddSEPage.vue";
import EditServiceEstimate from "@/pages/Dashboard/Workshop/ServiceEstimate/EditSEPage.vue";

import ListSparePartMaster from "@/pages/Dashboard/Workshop/SparePartMaster/ListSPMPage.vue";
import AddSparePartMaster from "@/pages/Dashboard/Workshop/SparePartMaster/AddSPMPage.vue";
import EditSparePartMaster from "@/pages/Dashboard/Workshop/SparePartMaster/EditSPMPage.vue";

import ListNotaJasaBkl from "@/pages/Dashboard/Workshop/NotaJasaBkl/ListNJBPage.vue";
import AddNotaJasaBkl from "@/pages/Dashboard/Workshop/NotaJasaBkl/AddNJBPage.vue";
import EditNotaJasaBkl from "@/pages/Dashboard/Workshop/NotaJasaBkl/EditNJBPage.vue";
import DetailNotaJasaBkl from "@/pages/Dashboard/Workshop/NotaJasaBkl/DetailNJBPage.vue";


import ListSparePartTransfer from "@/pages/Dashboard/Workshop/SparePartTransfer/ListSPTPage.vue";
import ListSparePartRequest from "@/pages/Dashboard/Workshop/SparePartRequest/ListSPRPage.vue";

import ListNotaPart from "@/pages/Dashboard/Workshop/NotaPart/ListNPPage.vue";
import AddNotaPart from "@/pages/Dashboard/Workshop/NotaPart/AddNPPage.vue";
import EditNotaPart from "@/pages/Dashboard/Workshop/NotaPart/EditNPPage.vue";
import DetailNotaPart from "@/pages/Dashboard/Workshop/NotaPart/DetailNPPage.vue";

import ListVehicleTypeWorkshop from "@/pages/Dashboard/Workshop/VehicleType/ListVTPage.vue";
import AddVehicleType from "@/pages/Dashboard/Workshop/VehicleType/AddVTPage.vue";
import EditVehicleType from "@/pages/Dashboard/Workshop/VehicleType/EditVTPage.vue";

import ListVehicleWorkshop from "@/pages/Dashboard/Workshop/Vehicle/ListVPage.vue";
import AddVehicle from "@/pages/Dashboard/Workshop/Vehicle/AddVPage.vue";
import EditVehicle from "@/pages/Dashboard/Workshop/Vehicle/EditVPage.vue";
import DetailVehicle from "@/pages/Dashboard/Workshop/Vehicle/DetailVPage.vue";


import ListAuditSparepart from "@/pages/Dashboard/Workshop/Audit/ListASPPage.vue";
import ListAuditVehicleSparepart from "@/pages/Dashboard/Workshop/Audit/ListAVSPPage.vue";

import ListDailyClosing from "@/pages/Dashboard/Workshop/DailyClosing/ListDCPage.vue";
import AddDailyClosing from "@/pages/Dashboard/Workshop/DailyClosing/AddDCPage.vue";

import ListChecker from "@/pages/Dashboard/Workshop/Checker/ListCPage.vue";
import AddChecker from "@/pages/Dashboard/Workshop/Checker/AddCPage.vue";
import EditChecker from "@/pages/Dashboard/Workshop/Checker/EditCPage.vue";
import DetailChecker from "@/pages/Dashboard/Workshop/Checker/DetailCPage.vue";

import ListParking from "@/pages/Dashboard/Workshop/Parking/ListPPage.vue";
import AddParking from "@/pages/Dashboard/Workshop/Parking/AddPPage.vue";
import EditParking from "@/pages/Dashboard/Workshop/Parking/EditPPage.vue";

import ListParkingLine from "@/pages/Dashboard/Workshop/ParkingLine/ListPLPage.vue";
import AddParkingLine from "@/pages/Dashboard/Workshop/ParkingLine/AddPLPage.vue";
import EditParkingLine from "@/pages/Dashboard/Workshop/ParkingLine/EditPLPage.vue";

import ListGatePass from "@/pages/Dashboard/Workshop/GatePass/ListGPPage.vue";
import AddGatePass from "@/pages/Dashboard/Workshop/GatePass/AddGPPage.vue";
import EditGatePass from "@/pages/Dashboard/Workshop/GatePass/EditGPPage.vue";
import DetailGatePass from "@/pages/Dashboard/Workshop/GatePass/DetailGPPage.vue";

import ListPool from "@/pages/Dashboard/Workshop/Eshed/ListPPage.vue";
import ListWarehouse from "@/pages/Dashboard/Workshop/Warehouse/ListWPage.vue";
import ListVehicleBrand from "@/pages/Dashboard/Workshop/Warehouse/ListWPage.vue";


import LayoutClick from "@/pages/Dashboard/Finance/click/LayoutClick.vue";
import ListAppEnq from "@/pages/Dashboard/Finance/click/ListAppEnq.vue";
// import NewAppEnq from "@/pages/Dashboard/Finance/click/NewAppEnq.vue";



let fmsMenu = {
  path: "/fms",
  component: DashboardLayout,
  name: "Fms",
  children: [
    {
      path: "dashboard",
      name: "Dashboard Fms",
      group: "Dashboard",
      components: { default: DashboardFms },
      meta: { middleware: auth },
    },

    {
      path: "list-business-unit",
      name: "List Business Unit",
      group: "FmsBusinessUnits",
      components: { default: ListBusinessUnit },
      //meta: { middleware: [auth, admin] }
      meta: { middleware: auth },
    },

    {
      path: "list-city",
      name: "List City",
      group: "FmsCitys",
      components: { default: ListCity },
      meta: { middleware: auth },
    },

    {
      path: "list-dp-amount",
      name: "List Dp Amount",
      group: "FmsDpAmounts",
      components: { default: ListDpAmount },
      meta: { middleware: auth },
    },

    {
      path: "list-driver",
      name: "List Driver",
      group: "FmsDrivers",
      components: { default: ListDriver },
      meta: { middleware: auth },
    },

    {
      path: "list-driver-dp",
      name: "List Driver DP",
      group: "FmsDriverDps",
      components: { default: ListDriverDp },
      meta: { middleware: auth },
    },

    {
      path: "list-payment-plan",
      name: "List Payment Plan",
      group: "FmsPaymentPlans",
      components: { default: ListPaymentPlan },
      meta: { middleware: auth },
    },

    {
      path: "list-pko",
      name: "List PKO",
      group: "FmsPkos",
      components: { default: ListPko },
      meta: { middleware: auth },
    },

    {
      path: "list-spj",
      name: "List Spj",
      group: "FmsSpjs",
      components: { default: ListSpj },
      meta: { middleware: auth },
    },

    {
      path: "list-vehicle",
      name: "List Vehicle",
      group: "FmsVehicles",
      components: { default: ListVehicle },
      meta: { middleware: auth },
    },

    {
      path: "list-cashier",
      name: "List Cashier",
      group: "FmsCashiers",
      components: { default: ListCashier },
      meta: { middleware: auth },
    },
  ],
};

let adminMenu = {
  path: "/admin",
  component: DashboardLayout,
  name: "Admin",
  children: [
    {
      path: "user-management/list-users",
      name: "List Users Management",
      group: "User",
      components: { default: ListUserPageTest },
      meta: { middleware: auth },
    },
    {
      path: "user-management/add-users",
      name: "Add Users",
      group: "User",
      components: { default: AddUserPageTest },
      meta: { middleware: auth },
    },
    {
      path: "user-management/edit-users",
      name: "Edit Users",
      group: "User",
      components: { default: EditUserPageTest },
      meta: { middleware: auth },
    },
    {
      path: "role/list-role",
      name: "List Role",
      group: "Role",
      components: { default: ListRole },
      // meta: { middleware: [auth, admin] }
      meta: { middleware: auth },
    },
    {
      path: "role/add-role",
      name: "Add Role",
      group: "Role",
      components: { default: AddRole },
      meta: { middleware: auth },
    },
    {
      path: "role/edit-role",
      name: "Edit Role",
      group: "Role",
      components: { default: EditRole },
      meta: { middleware: auth },
    },
  ],
};


let workshopMenu = {
  path: "/workshop",
  component: DashboardLayout,
  name: "Workshop",
  children: [
    {
      path: "dashboard",
      name: "Dashboard Workshop",
      group: "Dashboard",
      components: { default: DashboardWorkshop },
      meta: { middleware: auth },
    },
    {
      path: "service-categories/list-service-categories",
      name: "List Service Categories",
      group: "WorkshopServiceCategories",
      components: { default: ListServiceCategories },
      meta: { middleware: auth },
    },
    {
      path: "service-categories/add-service-categories",
      name: "Add Service Categories",
      group: "WorkshopServiceCategories",
      components: { default: AddServiceCategories },
      meta: { middleware: auth },
    },
    {
      path: "service-categories/edit-service-categories",
      name: "Edit Service Categories",
      group: "WorkshopServiceCategories",
      components: { default: EditServiceCategories },
      meta: { middleware: auth },
    },
    {
      path: "service-master/list-service-master",
      name: "List Service Master",
      group: "WorkshopServiceMasters",
      components: { default: ListServiceMaster },
      meta: { middleware: auth },
    },
    {
      path: "service-master/add-service-master",
      name: "Add Service Master",
      group: "WorkshopServiceMasters",
      components: { default: AddServiceMaster },
      meta: { middleware: auth },
    },
    {
      path: "service-master/edit-service-master",
      name: "Edit Service Master",
      group: "WorkshopServiceMasters",
      components: { default: EditServiceMaster },
      meta: { middleware: auth },
    },
    {
      path: "part-dealer/list-part-dealer",
      name: "List Part Dealer",
      group: "WorkshopPartDealers",
      components: { default: ListPartDealer },
      meta: { middleware: auth },
    },
    {
      path: "part-dealer/add-part-dealer",
      name: "Add Part Dealer",
      group: "WorkshopPartDealers",
      components: { default: AddPartDealer },
      meta: { middleware: auth },
    },
    {
      path: "part-dealer/edit-part-dealer",
      name: "Edit Part Dealer",
      group: "WorkshopPartDealers",
      components: { default: EditPartDealer },
      meta: { middleware: auth },
    },
    {
      path: "procurement-order/list-procurement-order",
      name: "List Procurement Order",
      group: "WorkshopProcurementOrders",
      components: { default: ListProcurementOrder },
      meta: { middleware: auth },
    },
    {
      path: "procurement-order/add-procurement-order",
      name: "Add Procurement Order",
      group: "WorkshopProcurementOrders",
      components: { default: AddProcurementOrder },
      meta: { middleware: auth },
    },
    {
      path: "procurement-order/edit-procurement-order",
      name: "Edit Procurement Order",
      group: "WorkshopProcurementOrders",
      components: { default: EditProcurementOrder },
      meta: { middleware: auth },
    },
    {
      path: "procurement-order/detail-procurement-order/:id",
      name: "Detail Procurement Order",
      group: "WorkshopProcurementOrders",
      components: { default: DetailProcurementOrder },
      meta: { middleware: auth },
    },
    {
      path: "spare-part-master/list-spare-part-master",
      name: "List Spare Part Master",
      group: "WorkshopSparePartMasters",
      components: { default: ListSparePartMaster },
      meta: { middleware: auth },
    },
    {
      path: "spare-part-master/add-spare-part-master",
      name: "Add Spare Part Master",
      group: "WorkshopSparePartMasters",
      components: { default: AddSparePartMaster },
      meta: { middleware: auth },
    },
    {
      path: "spare-part-master/edit-spare-part-master",
      name: "Edit Spare Part Master",
      group: "WorkshopSparePartMasters",
      components: { default: EditSparePartMaster },
      meta: { middleware: auth },
    },
    {
      path: "client-master/list-client-master",
      name: "List Client Master",
      group: "WorkshopClientMasters",
      components: { default: ListClientMaster },
      meta: { middleware: auth },
    },
    {
      path: "client-master/add-client-master",
      name: "Add Client Master",
      group: "WorkshopClientMasters",
      components: { default: AddClientMaster },
      meta: { middleware: auth },
    },
    {
      path: "client-master/edit-client-master",
      name: "Edit Client Master",
      group: "WorkshopClientMasters",
      components: { default: EditClientMaster },
      meta: { middleware: auth },
    },
    {
      path: "service-estimate/list-service-estimate",
      name: "List Service Estimate",
      group: "WorkshopServiceEstimates",
      components: { default: ListServiceEstimate },
      meta: { middleware: auth },
    },
    {
      path: "service-estimate/detail-service-estimate/:id",
      name: "Detail Service Estimate",
      group: "WorkshopServiceEstimates",
      components: { default: DetailServiceEstimate },
      meta: { middleware: auth },
    },
    {
      path: "service-estimate/add-service-estimate",
      name: "Add Service Estimate",
      group: "WorkshopServiceEstimates",
      components: { default: AddServiceEstimate },
      meta: { middleware: auth },
    },
    {
      path: "service-estimate/edit-service-estimate",
      name: "Edit Service Estimate",
      group: "WorkshopServiceEstimates",
      components: { default: EditServiceEstimate },
      meta: { middleware: auth },
    },
    {
      path: "pkb/list-pkb",
      name: "List PKB",
      group: "WorkshopPkbs",
      components: { default: ListPKB },
      meta: { middleware: auth },
    },
    {
      path: "pkb/detail-pkb/:id",
      name: "Detail PKB",
      group: "WorkshopPkbs",
      components: { default: DetailPKB },
      meta: { middleware: auth },
    },
    {
      path: "pkb/add-pkb",
      name: "Add PKB",
      group: "WorkshopPkbs",
      components: { default: AddPKB },
      meta: { middleware: auth },
    },
    {
      path: "pkb/edit-pkb",
      name: "Edit PKB",
      group: "WorkshopPkbs",
      components: { default: EditPKB },
      meta: { middleware: auth },
    },
    {
      path: "faktur/list-faktur",
      name: "List Faktur",
      group: "WorkshopFakturs",
      components: { default: ListFaktur },
      meta: { middleware: auth },
    },
    {
      path: "faktur/add-faktur",
      name: "Add Faktur",
      group: "WorkshopFakturs",
      components: { default: AddFaktur },
      meta: { middleware: auth },
    },
    {
      path: "faktur/edit-faktur",
      name: "Edit Faktur",
      group: "WorkshopFakturs",
      components: { default: EditFaktur },
      meta: { middleware: auth },
    },
    {
      path: "faktur/detail-faktur/:id",
      name: "Detail Faktur",
      group: "WorkshopFakturs",
      components: { default: DetailFaktur },
      meta: { middleware: auth },
    },
    {
      path: "faktur/pdf-faktur/:id",
      name: "Pdf Faktur",
      group: "WorkshopFakturs",
      components: { default: PdfFaktur },
      meta: { middleware: auth },
    },
    {
      path: "nota-jasa-bkl/list-nota-jasa-bkl",
      name: "List Nota Jasa Bkl",
      group: "WorkshopFakturs",
      components: { default: ListNotaJasaBkl },
      meta: { middleware: auth },
    },
    {
      path: "nota-jasa-bkl/add-nota-jasa-bkl",
      name: "Add Nota Jasa Bkl",
      group: "WorkshopNotaJasaBkls",
      components: { default: AddNotaJasaBkl },
      meta: { middleware: auth },
    },
    {
      path: "nota-jasa-bkl/edit-nota-jasa-bkl",
      name: "Edit Nota Jasa Bkl",
      group: "WorkshopNotaJasaBkls",
      components: { default: EditNotaJasaBkl },
      meta: { middleware: auth },
    },
    {
      path: "nota-jasa-bkl/detail-nota-jasa-bkl/:id",
      name: "Detail Nota Jasa Bkl",
      group: "WorkshopNotaJasaBkls",
      components: { default: DetailNotaJasaBkl },
      meta: { middleware: auth },
    },
    {
      path: "nota-part/list-nota-part",
      name: "List Nota Part",
      group: "WorkshopNotaParts",
      components: { default: ListNotaPart },
      meta: { middleware: auth },
    },
    {
      path: "nota-part/add-nota-part",
      name: "Add Nota Part",
      group: "WorkshopNotaParts",
      components: { default: AddNotaPart },
      meta: { middleware: auth },
    },
    {
      path: "nota-part/edit-nota-part",
      name: "Edit Nota Part",
      group: "WorkshopNotaParts",
      components: { default: EditNotaPart },
      meta: { middleware: auth },
    },
    {
      path: "nota-part/detail-nota-part/:id",
      name: "Detail Nota Part",
      group: "WorkshopNotaParts",
      components: { default: DetailNotaPart },
      meta: { middleware: auth },
    },
    {
      path: "workshop-vehicle-type/list-workshop-vehicle-type",
      name: "List Vehicle Type",
      group: "WorkshopVehicleTypes",
      components: { default: ListVehicleTypeWorkshop },
      //meta: { middleware: [auth, admin] }
      meta: { middleware: auth }
    },
    // {
    //   path: "vehicle-type/add-vehicle-type",
    //   name: "Add Vehicle Type",
    //   group: "WorkshopVehicleTypes",
    //   components: { default: AddVehicleType },
    //   meta: { middleware: auth }
    // },
    // {
    //   path: "vehicle-type/edit-vehicle-type",
    //   name: "Edit Vehicle Type",
    //   group: "WorkshopVehicleTypes",
    //   components: { default: EditVehicleType },
    //   meta: { middleware: auth }
    // },
    {
      path: "workshop-vehicle/list-workshop-vehicle",
      name: "List Workshop Vehicle",
      group: "WorkshopVehicles",
      components: { default: ListVehicleWorkshop },
      //meta: { middleware: [auth, admin] }
      meta: { middleware: auth }
    },
    // {
    //   path: "vehicle/add-vehicle",
    //   name: "Add Vehicle",
    //   group: "WorkshopVehicles",
    //   components: { default: AddVehicle },
    //   meta: { middleware: auth }
    // },
    // {
    //   path: "vehicle/edit-vehicle",
    //   name: "Edit Vehicle",
    //   group: "WorkshopVehicles",
    //   components: { default: EditVehicle },
    //   meta: { middleware: auth }
    // },
    // {
    //   path: "vehicle/detail-vehicle/:id",
    //   name: "Detail Vehicle",
    //   group: "WorkshopVehicles",
    //   components: { default: DetailVehicle },
    //   meta: { middleware: auth }
    // },
    // {
    //   path: "business-unit/list-business-unit",
    //   name: "List Business Unit",
    //   group: "WorkshopBusinessUnits",
    //   components: { default: ListBusinessUnit },
    //   //meta: { middleware: [auth, admin] }
    //   meta: { middleware: auth }
    // },
    // {
    //   path: "business-unit/add-business-unit",
    //   name: "Add Business Unit",
    //   group: "WorkshopBusinessUnits",
    //   components: { default: AddBusinessUnit },
    //   meta: { middleware: auth }
    // },
    // {
    //   path: "business-unit/edit-business-unit",
    //   name: "Edit Business Unit",
    //   group: "WorkshopBusinessUnits",
    //   components: { default: EditBusinessUnit },
    //   meta: { middleware: auth }
    // },


    {
      path: "audit/list-audit-sparepart",
      name: "List Audit Sparepart",
      group: "WorkshopAudits",
      components: { default: ListAuditSparepart },
      //meta: { middleware: [auth, admin] }
      meta: { middleware: auth },
    },
    {
      path: "audit/list-audit-vehicle-sparepart",
      name: "List Audit Vehicle Sparepart",
      group: "WorkshopAudits",
      components: { default: ListAuditVehicleSparepart },
      //meta: { middleware: [auth, admin] }
      meta: { middleware: auth },
    },



    {
      path: "daily-closing/list-daily-closing",
      name: "List Daily Closing",
      group: "WorkshopDailyClosings",
      components: { default: ListDailyClosing },
      //meta: { middleware: [auth, admin] }
      meta: { middleware: auth },
    },

    {
      path: "daily-closing/add-daily-closing",
      name: "Add Daily Closing",
      group: "WorkshopDailyClosings",
      components: { default: AddDailyClosing },
      //meta: { middleware: [auth, admin] }
      meta: { middleware: auth },
    },

    {
      path: "parking/list-parking",
      name: "List Parking",
      group: "WorkshopParkings",
      components: { default: ListParking },
      //meta: { middleware: [auth, admin] }
      meta: { middleware: auth },
    },
    {
      path: "parking/add-parking",
      name: "Add Parking",
      group: "WorkshopParkings",
      components: { default: AddParking },
      //meta: { middleware: [auth, admin] }
      meta: { middleware: auth },
    },
    {
      path: "parking/edit-parking",
      name: "Edit Parking",
      group: "WorkshopParkings",
      components: { default: EditParking },
      //meta: { middleware: [auth, admin] }
      meta: { middleware: auth },
    },

    {
      path: "parking-line/list-parking-line",
      name: "List Parking Line",
      group: "WorkshopParkingLines",
      components: { default: ListParkingLine },
      //meta: { middleware: [auth, admin] }
      meta: { middleware: auth },
    },

    {
      path: "eshed/list-eshed",
      name: "List Eshed",
      group: "WorkshopPools",
      components: { default: ListPool },
      //meta: { middleware: [auth, admin] }
      meta: { middleware: auth },
    },

    {
      path: "warehouse/list-warehouse",
      name: "List Warehouse",
      group: "WorkshopWarehouses",
      components: { default: ListWarehouse },
      //meta: { middleware: [auth, admin] }
      meta: { middleware: auth },
    },



    {
      path: "parking-line/add-parking-line",
      name: "Add Parking Line",
      group: "WorkshopParkingLines",
      components: { default: AddParkingLine },
      //meta: { middleware: [auth, admin] }
      meta: { middleware: auth },
    },

    {
      path: "parking-line/edit-parking-line",
      name: "Edit Parking Line",
      group: "WorkshopParkingLines",
      components: { default: EditParkingLine },
      //meta: { middleware: [auth, admin] }
      meta: { middleware: auth },
    },



    {
      path: "spare-part-transfer/list-spare-part-transfer",
      name: "List Spare Part Transfer",
      group: "WorkshopSparePartTransfers",
      components: { default: ListSparePartTransfer },
      //meta: { middleware: [auth, admin] }
      meta: { middleware: auth },
    },
    {
      path: "spare-part-request/list-spare-part-request",
      name: "List Spare Part Request",
      group: "WorkshopSparePartRequests",
      components: { default: ListSparePartRequest },
      //meta: { middleware: [auth, admin] }
      meta: { middleware: auth },
    },
  ],
};

let financeMenu = {
  path: "/finance",
  component: DashboardLayout,
  name: "Finance",
  children: [
    {
      path: "click/list-click",
      name: "Click",
      group: "FinanceClicks",
      components: { default: LayoutClick },
      //meta: { middleware: [auth, admin] }
      meta: { middleware: auth },
    },
  ],
};



let userMenu = {
  path: "/user",
  component: DashboardLayout,
  name: "User",
  children: [
    {
      path: "user-profile",
      name: "User Profile",
      components: { default: UserProfile },
      meta: { middleware: auth },
    },


  ],
};

let landingMenu = {
  path: "/landing",
  name: "Landing Page",
  components: { default: Landing, header: MainNavbar },
  props: {
    header: { colorOnScroll: 400 },
    footer: { backgroundColor: "black" },
  },
  meta: {
    hideFooter: true,
  },
};

let homeMenu = {
  path: "/home",
  redirect: "/dashboard",
  name: "Home Page",
  components: { default: DashboardLayout },
};



let componentsMenu = {
  path: "/components",
  component: DashboardLayout,
  redirect: "/components/notification",
  name: "Components",
  children: [
    {
      path: "table",
      name: "Table",
      components: { default: RegularTables },
      meta: { middleware: auth },
    },
    {
      path: "typography",
      name: "Typography",
      components: { default: Typography },
      meta: { middleware: auth },
    },
    // {
    //   path: "parallax",
    //   name: "Parallax",
    //   components: { default: Parallax },
    //   meta: { middleware: auth }
    // },
    {
      path: "icons",
      name: "Icons",
      components: { default: Icons },
      meta: { middleware: auth },
    },
    {
      path: "maps",
      name: "Maps",
      meta: {
        hideContent: true,
        hideFooter: true,
        navbarAbsolute: true,
        middleware: auth,
      },
      components: { default: FullScreenMap },
    },
    {
      path: "notifications",
      name: "Notifications",
      components: { default: Notifications },
      meta: { middleware: auth },
    },
    {
      path: "rtl",
      name: "وحة القيادة",
      meta: {
        rtlActive: true,
        middleware: auth,
      },
      components: { default: RtlSupport },
    },
  ],
};

// let examplesMenu = {
//   path: "/examples",
//   component: DashboardLayout,
//   name: "Examples",
//   children: [
//     {
//       path: "user-profile",
//       name: "User Profile Examples",
//       components: { default: UserProfile },
//       meta: { middleware: auth }
//     },
//     {
//       path: "user-management/list-users",
//       name: "List Users",
//       components: { default: ListUserPage },
//       meta: { middleware: auth }
//     }
//   ]
// };

let authPages = {
  path: "/",
  component: AuthLayout,
  name: "Authentication",
  children: [
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: { middleware: guest },
    },
    {
      path: "/register",
      name: "Register",
      component: Register,
      meta: { middleware: guest },
    },
  ],
};

const routes = [
  {
    path: "/",
    redirect: "/dashboard",
    name: "Home",
  },
  {
    path: "/",
    component: DashboardLayout,
    meta: { middleware: auth },
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        components: { default: Dashboard },
        meta: { middleware: auth },
      },
    ],
  },

  componentsMenu,
  // examplesMenu,
  userMenu,
  adminMenu,
  workshopMenu,
  authPages,
  landingMenu,
  homeMenu,
  fmsMenu,
  financeMenu,

  { path: "/:pathMatch(.*)*", name: "Not Found", component: PathNotFound },
];

export default routes;
